import React, { useState, useEffect } from "react";
import BillingHistoryTable from "./BillingHistoryTable";
import { SortConfig } from "../ui/paginated-table";
import { BillingService } from "../../services/BillingService";
import { BillingTransaction } from "../../model_gen/billing";
import { usePermissions } from "../../PermissionsProvider";

const BillingHistory: React.FC = () => {
  const { apiKey } = usePermissions();
  const [transactions, setTransactions] = useState<BillingTransaction[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [sortConfig, setSortConfig] = useState<SortConfig<BillingTransaction>>({
    key: null,
    direction: "desc",
  });

  const pageSize = 10;

  useEffect(() => {
    if (apiKey) {
      fetchBillingHistory();
    }
  }, [apiKey]);

  const fetchBillingHistory = () => {
    setIsLoading(true);

    BillingService.getBillingHistory(100, null, apiKey).subscribe(
      (result: BillingTransaction[]) => {
        setTransactions(result);
        setIsLoading(false);
      },
      (error: any) => {
        console.error("Error fetching billing history:", error);
        setIsLoading(false);
      }
    );
  };

  const handleViewTransaction = (transaction: BillingTransaction) => {
    // Open the appropriate URL based on transaction type
    if (transaction.type === "invoice") {
      // For invoices, open the hosted invoice or PDF
      if (transaction.hosted_invoice_url) {
        window.open(transaction.hosted_invoice_url, "_blank");
      } else if (transaction.invoice_pdf) {
        window.open(transaction.invoice_pdf, "_blank");
      }
    } else if (transaction.type === "credit") {
      // For credit purchases, open the receipt if available
      if (transaction.receipt_url) {
        window.open(transaction.receipt_url, "_blank");
      } else {
        console.log(
          "No receipt available for this credit transaction:",
          transaction
        );
      }
    }
  };

  const handleSort = (key: keyof BillingTransaction) => {
    let direction: "asc" | "desc" = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  return (
    <div className="space-y-4">
      <div className="text-sm text-muted-foreground">
        Showing invoices and transactions
      </div>

      <BillingHistoryTable
        transactions={transactions}
        loading={isLoading}
        onViewTransaction={handleViewTransaction}
        emptyTitle="No billing history"
        emptyDescription="No transactions have been recorded yet."
        currentPage={currentPage}
        onPageChange={handlePageChange}
        pageSize={pageSize}
        sortConfig={sortConfig}
        onSort={handleSort}
        showPagination={true}
      />
    </div>
  );
};

export default BillingHistory;
